<!-- Content -->
<div class="section-main" [ngClass]="{'hide-header':isHideHeader, 'hide-footer':isHideFooter}">

  <!-- Header -->
  <app-header *ngIf="!isHideHeader"></app-header>

  <router-outlet/>

  <!-- Toast -->
  <app-toast></app-toast>
</div>

<!-- Footer -->
<app-footer *ngIf="!isHideFooter"></app-footer>
